import React from "react"
import { useTranslate } from "react-polyglot"

import { INewBadge } from "./INewBadge"

export const NewBadge = ({ label = "common.new", className }: INewBadge) => {
    const t = useTranslate()

    return (
        <span className={`a-newBadge${className ? ` ${className}` : ""}`}>
            {t(label)}
        </span>
    )
}

export default NewBadge
